import $ from 'jquery';

export default {
  init() {
    console.log("video single");
  },
  finalize() {
    /* Hide video tag on video play */
    $(".video").click( function() {
      $(".video .tag").fadeOut();
    })
  },
};
